// Arabic translations
const ar = {
  siteName: 'Brothers Phone',
  common: {
    loading: 'جاري التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    create: 'إنشاء',
    search: 'بحث',
    back: 'رجوع',
    yes: 'نعم',
    no: 'لا',
    add: 'إضافة',
    remove: 'إزالة',
    submit: 'إرسال',
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    register: 'التسجيل',
    home: 'الرئيسية',
    dashboard: 'لوحة التحكم',
    products: 'المنتجات',
    categories: 'الفئات',
    orders: 'الطلبات',
    cart: 'السلة',
    wishlist: 'قائمة الأمنيات',
    addToCart: 'أضف إلى السلة',
    addToWishlist: 'أضف إلى المفضلة',
    viewMore: 'عرض المزيد',
    outOfStock: 'نفذ من المخزن',
    addedToCart: 'تم إضافة المنتج إلى السلة!',
    addedToWishlist: 'تم إضافة المنتج إلى المفضلة!',
    addToCartError: 'فشل في إضافة المنتج إلى السلة',
    addToWishlistError: 'فشل في إضافة المنتج إلى المفضلة',
    loginRequired: 'يرجى تسجيل الدخول لإضافة العناصر إلى قائمة المفضلة',
    profile: 'الملف الشخصي',
    settings: 'الإعدادات',
    admin: 'الإدارة',
  },
  navigation: {
    home: 'الرئيسية',
    shop: 'المتجر',
    news: 'الأخبار',
    about: 'من نحن',
    contact: 'اتصل بنا',
    myAccount: 'حسابي',
    admin: 'لوحة الإدارة',
    profile: 'الملف الشخصي',
    orders: 'الطلبات',
    wishlist: 'قائمة الأمنيات',
    cart: 'السلة',
    login: 'تسجيل الدخول',
    register: 'التسجيل',
    logout: 'تسجيل الخروج',
  },
  auth: {
    username: 'اسم المستخدم',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    forgotPassword: 'نسيت كلمة المرور؟',
    alreadyHaveAccount: 'لديك حساب بالفعل؟',
    dontHaveAccount: 'ليس لديك حساب؟',
    loginSuccessful: 'تم تسجيل الدخول بنجاح!',
    registrationSuccessful: 'تم التسجيل بنجاح!',
    logoutSuccessful: 'تم تسجيل الخروج.',
    invalidCredentials: 'بيانات غير صحيحة.',
    unauthorizedAccess: 'وصول غير مصرح به.',
    sessionExpired: 'انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.',
  },
  products: {
    title: 'المنتجات',
    addToCart: 'إضافة للسلة',
    addToWishlist: 'إضافة للمفضلة',
    outOfStock: 'غير متوفر',
    inStock: 'متوفر',
    price: 'السعر',
    quantity: 'الكمية',
    description: 'الوصف',
    name: 'الاسم',
    category: 'الفئة',
    searchPlaceholder: 'البحث عن المنتجات...',
    filter: 'تصفية',
    sort: 'ترتيب',
    noProductsFound: 'لم يتم العثور على منتجات.',
    createNew: 'إنشاء منتج جديد',
    edit: 'تعديل المنتج',
    delete: 'حذف المنتج',
    deleteConfirmation: 'هل أنت متأكد من حذف هذا المنتج؟',
  },
  cart: {
    title: 'سلة التسوق',
    empty: 'سلة التسوق فارغة.',
    continueShipping: 'متابعة التسوق',
    subtotal: 'المجموع الفرعي',
    total: 'المجموع',
    checkout: 'الدفع',
    removeFromCart: 'إزالة من السلة',
    updateQuantity: 'تحديث الكمية',
    itemAdded: 'تم إضافة العنصر للسلة!',
    itemRemoved: 'تم إزالة العنصر من السلة!',
    itemUpdated: 'تم تحديث السلة!',
  },
  orders: {
    title: 'الطلبات',
    orderNumber: 'رقم الطلب',
    date: 'التاريخ',
    status: 'الحالة',
    total: 'المجموع',
    details: 'عرض التفاصيل',
    noOrdersFound: 'لم يتم العثور على طلبات.',
    createNew: 'إنشاء طلب جديد',
    placeOrder: 'تأكيد الطلب',
    orderPlaced: 'تم تأكيد الطلب بنجاح!',
    orderCancelled: 'تم إلغاء الطلب!',
    cancelOrder: 'إلغاء الطلب',
    pending: 'في الانتظار',
    processing: 'قيد التجهيز',
    shipped: 'تم الشحن',
    delivered: 'تم التسليم',
    cancelled: 'ملغي',
  },
  news: {
    title: 'آخر الأخبار والتحديثات',
    subtitle: 'ابق على اطلاع بأحدث منتجاتنا وإعلاناتنا',
    featuredImage: 'الصورة المميزة',
    logoAnimation: 'علامتنا التجارية',
    socialMedia: 'تابعونا',
    youtubeVideos: 'أحدث الفيديوهات',
    noContent: 'لا يوجد محتوى إخباري متاح في الوقت الحالي.',
    managePage: 'إدارة صفحة الأخبار',
    updateContent: 'تحديث المحتوى',
    uploadImage: 'رفع صورة',
    addVideo: 'إضافة فيديو يوتيوب',
    videoUrl: 'رابط فيديو يوتيوب',
    socialLinks: 'روابط وسائل التواصل الاجتماعي',
    facebook: 'فيسبوك',
    instagram: 'إنستغرام',
    twitter: 'تويتر',
    youtube: 'يوتيوب',
    tiktok: 'تيك توك',
  },
  footer: {
    about: 'من نحن',
    contact: 'اتصل بنا',
    terms: 'شروط الخدمة',
    privacy: 'سياسة الخصوصية',
    copyright: '© 2025 Brothers Phone. جميع الحقوق محفوظة.',
  },
};

export default ar;
